export const HOST_APP_ERRORS = {
  rendering: 'HostAppRenderingError',
} as const;
